import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Mail } from 'lucide-react';

const EmailSignup = () => {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setSubmitted(true);
    setTimeout(() => setSubmitted(false), 3000);
    setEmail('');
  };

  return (
    <section className="py-20 bg-[#0F0F0F] text-white border-t border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl md:text-5xl font-display font-bold mb-4">
  <span className="text-white">Join Our</span> <span className="text-brandred">Tacoma Community</span>
</h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Get install tips, first access to new parts, and special offers just for Toyota truck owners.
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="bg-gray-50 rounded-2xl p-8 border border-gray-200 shadow-lg flex flex-col md:flex-row gap-8 items-center justify-between"
        >
          {/* Benefits */}
          <div className="flex-1 space-y-6">
            <div className="flex items-center gap-4">
              <div className="w-10 h-10 bg-brandred/10 rounded-lg flex items-center justify-center">
                <Mail className="text-brandred" size={24} />
              </div>
              <div>
                <div className="font-semibold text-black">Exclusive Access</div>
                <div className="text-gray-600 text-sm">First access to new product drops and member-only sales</div>
              </div>
            </div>
            <div className="flex items-center gap-4">
              <div className="w-10 h-10 bg-brandred/10 rounded-lg flex items-center justify-center">
                <Mail className="text-brandred" size={24} />
              </div>
              <div>
                <div className="font-semibold text-black">Tips & DIY Guides</div>
                <div className="text-gray-600 text-sm">Expert installation tips and step-by-step guides</div>
              </div>
            </div>
            <div className="flex items-center gap-4">
              <div className="w-10 h-10 bg-brandred/10 rounded-lg flex items-center justify-center">
                <Mail className="text-brandred" size={24} />
              </div>
              <div>
                <div className="font-semibold text-black">Free Shipping</div>
                <div className="text-gray-600 text-sm">Free shipping on orders $100+ for newsletter subscribers</div>
              </div>
            </div>
          </div>

          {/* Signup Form */}
          <div className="bg-white rounded-xl p-6 flex flex-col gap-4 border border-gray-200 shadow-lg">
            <div className="flex items-center gap-2 mb-2">
              <Mail className="text-brandred" size={20} /> <span className="font-semibold text-black">Join Our Newsletter</span>
            </div>
            <form onSubmit={handleSubmit} className="space-y-4">
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter your email address"
                required
                className="w-full px-4 py-3 rounded-lg bg-gray-50 border border-gray-300 text-black placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-brandred focus:border-transparent transition-all duration-300"
              />
              <button
                type="submit"
                className="w-full bg-brandred text-offwhite font-bold text-lg py-3 mt-2 rounded-lg shadow-lg hover:bg-gradient-to-r hover:from-brandred hover:to-[#E63B3B] transition-all duration-300"
                disabled={submitted}
              >
                {submitted ? 'Subscribed!' : 'Subscribe Now'}
              </button>
            </form>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default EmailSignup; 